
export default {
    props: ['list']
}
